import { v } from 'convex/values'

export type TodaySection = 'focus' | 'habits' | 'quick'

export const DEFAULT_TODAY_SECTION_ORDER: TodaySection[] = ['habits', 'focus', 'quick']

export const todaySectionValidator = v.union(
  v.literal('focus'),
  v.literal('habits'),
  v.literal('quick'),
)

// Stored order may be missing, stale, or partial (e.g. a section added later) —
// keep known entries once, in stored order, then append the rest by default.
export function resolveTodaySectionOrder(order: readonly string[] | undefined): TodaySection[] {
  const out: TodaySection[] = []
  for (const s of order ?? []) {
    if (DEFAULT_TODAY_SECTION_ORDER.includes(s as TodaySection) && !out.includes(s as TodaySection))
      out.push(s as TodaySection)
  }
  for (const s of DEFAULT_TODAY_SECTION_ORDER) if (!out.includes(s)) out.push(s)
  return out
}
